module.exports = __webpack_public_path__ + "img/circle-pause.15cbc125.svg";